var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tcgaExpAll"},[_c('div',{staticStyle:{"height":"500px"},attrs:{"id":"umapRegularGene"}})])
}]

export { render, staticRenderFns }